import { FacebookIcon, InstagramIcon, TripadvisorIcon, YoutubeIcon } from 'shared-widget-components/src/components/Icons';

interface SocialIconProps {
  icon: string;
  link?: string;
  iconColor?: string;
}
// közösségi média ikonok megjelenítése, és hozzá tartozó linkek
const SocialIcon = ({ icon, link, iconColor }: SocialIconProps) => {
  // @ts-ignore
  const isAdmin = window.isAdminPage;

  // navigate to the link when the icon is clicked
  const onIconClick = () => {
    // @ts-ignore
    if (window.isAdminPage) return;

    window.open(link, '_blank');
  };

  return (
    <div className='mt-1 flex ' style={{ color: iconColor }}>
      {icon === 'facebook' && (
        <button className='cursor-pointer outline-none active:outline-none focus:outline-none' type='button' style={{ color: iconColor }} onClick={onIconClick}>
          <FacebookIcon iconColor={iconColor} />
        </button>
      )}
      {icon === 'instagram' && (
        <button className='cursor-pointer outline-none active:outline-none focus:outline-none' type='button' style={{ color: iconColor }} onClick={onIconClick}>
          <InstagramIcon iconColor={iconColor} />
        </button>
      )}
      {icon === 'tripadvisor' && (
        <button className='cursor-pointer outline-none active:outline-none focus:outline-none' type='button' style={{ color: iconColor }} onClick={onIconClick}>
          <TripadvisorIcon iconColor={iconColor} />
        </button>
      )}
      {icon === 'youtube' && (
        <button className='cursor-pointer outline-none active:outline-none focus:outline-none' type='button' style={{ color: iconColor }} onClick={onIconClick}>
          <YoutubeIcon iconColor={iconColor} />
        </button>
      )}
    </div>
  );
};

export default SocialIcon;
